import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { useState} from "react";
// import React from "react";
// import TopStrip from "./Components/NAVBAR/TopStrip";
// import Top from "./Components/NAVBAR/Top";
// import NavBar from "./Components/NAVBAR/NavBar";
// import Footer from "./Components/NAVBAR/Footer";
import Home from "./Components/Home";
import { ColorProvider } from "./Components/ColorContext";
// import ColorButtons from "./Components/ColorButtons";
import CollegeHistory from "./Components/AboutUs/CollegeHistory";
import PrincipalsMessage from "./Components/AboutUs/PrincipalsMessage";
import IQAC from "./Components/Administration/IQAC";
import Courses from "./Components/Courses/Courses";
// import FacultyCard from "./Components/Faculty/FacultyCard";
import FacultyOfScrince from "./Components/Faculty/FacultyOfScrince";
import FacultyOfCommerce from "./Components/Faculty/FacultyOfCommerce";
import NonTeachingStaff from "./Components/Faculty/NonTeachingStaff";
import MultipurposeHallMultipurposeHall from "./Components/Facilites/MultipurposeHallMultipurposeHall";
import Facilites from "./Components/Facilites/Facilites";
import PhotoGallery from "./Components/GAllery/Photo";
import VideoGallery from "./Components/GAllery/Video";
import News from "./Components/GAllery/News";
import ContactUs from "./Components/Contactus/ContactUs";
// import axios from "axios";
// import { useDispatch } from "react-redux";
import AdmissionHomePage from "./Components/Admission/AdmissionHomePage";
import AdmissionFormPrint from "./pages/AdmissionFormPrint";
import AdmissionBaseLayout from "./pages/AdmissionBaseLayout";
import LoginPage from "./Components/Student/LoginPage";
import Dashboard from "./Components/Student/Dashboard";
import PrivateRoute from "./Components/Student/PrivateRoute";
import AdmissionPortalLayout from "./Components/AdmissionPortalLayout";
import ApplicationFromPrivateRoute from "./Components/Student/ApplicationFromPrivateRoute";
import PrivateRoute1stYear from "./Components/Student/PrivateRoute1stYear";
import PrivateRoute2ndYear from "./Components/Student/PrivateRoute2ndYear";
import MainPage from "./pages/MainPage";

import { useEffect } from "react";
import getUser from "./auth/userGetApi";
import { useDispatch } from "react-redux";
function App() {
  // const [loading, setLoading] = useState(true);
  // const [percentage, setPercentage] = useState(5);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // Make the API request using Axios
  //       const response = await axios.get(
  //         "https://campus.acetians.in/api/v1/get-store-data"
  //       );
  //       const response2 = await axios.get(
  //         "https://campus.acetians.in/api/v1/get-store-sliders"
  //       );
  //       const response3 = await axios.get(
  //         "https://campus.acetians.in/api/v1/get-store-notices"
  //       );
  //       const response4 = await axios.get(
  //         "https://campus.acetians.in/api/v1/get-store-gallery"
  //       );
  //       const response5 = await axios.get(
  //         "https://campus.acetians.in/api/v1/get-course-data"
  //       );
  //       // Dispatch data to the store
  //       dispatch({ type: "SET_STORE_DATA", payload: response.data });
  //       dispatch({ type: "SET_STORE_SLIDERS", payload: response2.data });
  //       dispatch({ type: "SET_NOTICES", payload: response3.data });
  //       dispatch({ type: "SET_GALLERY_IMAGES", payload: response4.data });
  //       dispatch({ type: "SET_COURSE_DATA", payload: response5.data });
  //     } catch (error) {
  //       // Handle errors
  //       console.error("Error fetching data", error);
  //     } finally {
  //       // Set loading to false after request completion
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [dispatch, percentage]);

  // useEffect(() => {
  //   if (loading) {
  //     const interval = setInterval(() => {
  //       setPercentage((prev) => {
  //         if (prev < 95) {
  //           return prev + 1;
  //         } else {
  //           clearInterval(interval);
  //           return prev;
  //         }
  //       });
  //     }, 10); // Adjust the interval time as needed
  //     return () => clearInterval(interval);
  //   } else {
  //     setPercentage(100);
  //   }
  // }, [loading]);

  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      const res = await getUser(localStorage.getItem("tokken"));

      dispatch({ type: "USERDATA", payload: res });

      console.log("Yea dta hia ", res);
    };

    getData();
  }, []);

  return (
    <ColorProvider>
      <>
        <BrowserRouter>
          {/* <ColorButtons />
          <TopStrip />
          <Top />
          <NavBar /> */}

          <Routes>
            <Route element={<AdmissionPortalLayout />}>
              <Route path="/" element={<Home />} />

              <Route
                path="/id-card/:name"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admission-form"
                element={
                  <PrivateRoute>
                    <AdmissionHomePage />
                  </PrivateRoute>
                }
              />

              <Route
                path="/student/dashbaord"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
            </Route>

            <Route
              path="/admission/:course/:part"
              element={
                <ApplicationFromPrivateRoute></ApplicationFromPrivateRoute>
              }
            />

            <Route
              path="/admission-form/ba/part-1"
              element={
                <PrivateRoute2ndYear>
                  <AdmissionBaseLayout
                    part={"Part-1"}
                    course={"BA"}
                    courseFullName={"Bachelor of Arts"}
                  />
                </PrivateRoute2ndYear>
              }
            />

            <Route
              path="/admission-form/bsc/part-1"
              element={
                <PrivateRoute2ndYear>
                  <AdmissionBaseLayout
                    part={"Part-1"}
                    course={"BSC"}
                    courseFullName={"Bachelor of Science"}
                  />
                </PrivateRoute2ndYear>
              }
            />

            <Route
              path="/admission-form/bcom/part-1"
              element={
                <PrivateRoute2ndYear>
                  <AdmissionBaseLayout
                    part={"Part-1"}
                    course={"BCOM"}
                    courseFullName={"Bachelor of Commerce"}
                  />
                </PrivateRoute2ndYear>
              }
            />

            <Route
              path="/admission-form/ba/part-2"
              element={
                <PrivateRoute1stYear>
                  <AdmissionBaseLayout
                    part={"Part-2"}
                    course={"BA"}
                    courseFullName={"Bachelor of Arts"}
                  />
                </PrivateRoute1stYear>
              }
            />

            <Route
              path="/admission-form/bsc/part-2"
              element={
                <PrivateRoute1stYear>
                  <AdmissionBaseLayout
                    part={"Part-2"}
                    course={"BSC"}
                    courseFullName={"Bachelor of Science"}
                  />
                </PrivateRoute1stYear>
              }
            />

            <Route
              path="/admission-form/bcom/part-2"
              element={
                <PrivateRoute1stYear>
                  <AdmissionBaseLayout
                    part={"Part-2"}
                    course={"BCOM"}
                    courseFullName={"Bachelor of Commerce"}
                  />
                </PrivateRoute1stYear>
              }
            />

            <Route
              path="/admission-form/print/:id"
              element={ 
                  <AdmissionFormPrint /> 
              
              }
            />

            {/*
            <Route path="/about/college_history" element={<CollegeHistory />} />
            <Route
              path="/about/principals-message/"
              element={<PrincipalsMessage />}
            />

          

             <Route path="/administration/iqac" element={<IQAC />} />

  

            <Route path="/faculty-of-science" element={<FacultyOfScrince />} />
            <Route
              path="/faculties-staff/faculty-of-commerce/"
              element={<FacultyOfCommerce />}
            />
            <Route
              path="/faculties-staff/non-teaching-staff/"
              element={<NonTeachingStaff />}
            />

            <Route path="/courses" element={<Courses />} />

            <Route
              path="/facilities/multipurpose-hall/"
              element={<MultipurposeHallMultipurposeHall />}
            />

            <Route path="/facilities" element={<Facilites />} />
            <Route path="/gallery/news/" element={<News />} />
            <Route path="/contact-us/" element={<ContactUs />} />
            <Route path="/gallery/video/" element={<VideoGallery />} />

            <Route
              path="/gallery/photo"
              element={<PhotoGallery galleryType="Photo" />}
            /> */}
          </Routes>

          {/* <Footer /> */}
        </BrowserRouter>
      </>
    </ColorProvider>
  );
}

export default App;
